export function init(signInStatusChanged) {
    function triggerSignInCallback() {
      if (gapi.auth2.getAuthInstance().isSignedIn.get()) {
        signInStatusChanged(gapi.auth2.getAuthInstance().currentUser.get().getBasicProfile().getEmail());
        } else {
            signInStatusChanged(null);
        }
    }
            
    gapi.load('client:auth2', function() {
        console.log("auth2 loaded");
        gapi.client.init({
            'apiKey': 'AIzaSyBE_b6Wt5Si2uqspGvXpHIikntP4NmSfmA',
            'discoveryDocs': ['https://people.googleapis.com/$discovery/rest', 'https://sheets.googleapis.com/$discovery/rest?version=v4'],
            'clientId': '752145289053-880thsmvv0amopqdiq2rr4o3j6g9uidi.apps.googleusercontent.com',
            'scope': 'https://www.googleapis.com/auth/drive',
        }).then(function() {
            console.log("init then");
            gapi.auth2.getAuthInstance().isSignedIn.listen(triggerSignInCallback);
            triggerSignInCallback();
        }, function(e) { console.log("Err init gapi", e);});
    });
}

export function signIn() {
  gapi.auth2.getAuthInstance().signIn();
}

export function signOut() {
  gapi.auth2.getAuthInstance().signOut();
}

function formatDate(date) {
    const year = date.getFullYear().toString();
    const m = (date.getMonth() + 1).toString();
    const month = m.length == 1 ? "0" + m : m;
    const day = date.getDate().toString();
    return `${year}-${month}-${day}`;
}

export function loadBookFromISBN(isbn) {
    // Instead of using gapi, perform a direct fetch, because a gapi
    // initialized with OAuth credentials seems to default to using
    // authenticated requests, which then requires us to get permissions to
    // "manage a user's books" which we do not need.
    return fetch(`https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}`).then((r) => r.json())
    .then((result) => {
        if (result.totalItems == 0) {
            return Promise.reject("No book found");
        }
        console.log(result);
        let {title, authors} = result.items[0].volumeInfo;
        return {
            title: title,
            author: authors.join(', '),
            readDate: formatDate(new Date()),
        };
    });
}

export function logToSpreadsheet(email, book) {
    console.log("APPENDING TO sheet", book);
    // This is much easier than implementing a file picker for now.
    const emailToSheet = {
        'nsm.nikhil@gmail.com': '1zKBIG6VY07RPyGhy_QuDK1xW__YTyHTcFTWknKPaPiU',
    };
    var params = {
        spreadsheetId: emailToSheet[email],
        range: 'Sheet1',
        valueInputOption: 'USER_ENTERED',
    };
    var body = {
        range: "Sheet1",
        majorDimension: "ROWS",
        values: [[book.title, book.author, book.readDate]],
    };

    var request = gapi.client.sheets.spreadsheets.values.append(params, body);
    return request.then(function(response) {
        console.log("Response", response.result);
        return book;
    }, function(response) {
        return Promise.reject(response.result.error.message);
    });
}
